import React from 'react';
import { Box, Heading, Flex } from '@chakra-ui/react';

const LineupsPage = () => (
  <Box p={8} color="white">
    <Flex align="center" mb={4} gap={4}>
      <Heading
        as="h1"
        fontFamily="Audiowide"
        fontWeight="bold"
        color="white"
        flex="1"
        textAlign="left"
        fontSize="2xl"
        m={0}
        p={0}
        whiteSpace="nowrap"
      >
        Lineups
      </Heading>
      <Box flex="2" display="flex" justifyContent="center">
        <Box
          px={8}
          py={2}
          fontSize="2xl"
          fontWeight="bold"
          color="white"
          bg="#2456d6"
          transform="skew(-20deg)"
          boxShadow="md"
          minW="180px"
          textAlign="center"
        >
          <span style={{ display: 'inline-block', transform: 'skew(20deg)' }}>Team Name</span>
        </Box>
      </Box>
      <Box flex="1" />
    </Flex>
  </Box>
);

export default LineupsPage; 